<div #naicsPanel></div>
<div (click)="toggleNode($event)" class="selected-info" [matTooltip]="selectedCodes" matTooltipPosition="above">
  <div class="selected-codes">
    {{ selectedCodes }}
  </div>

  <mat-icon *ngIf="selectedCodes" aria-label="Close icon" class="clear" (click)="clearSelectedNode($event)"
    >close</mat-icon
  >
</div>

<p-overlayPanel #naicsOverlay [dismissable]="true" [appendTo]="naicsPanel">
  <div class="naics-container">
    <div class="searchbox">
      <input
        class="searchBox"
        type="text"
        autocomplete="no-autofill"
        [formControl]="searchBar"
        [placeholder]="'overlayDetails.search' | xTranslate"
      />
      <mat-icon>search</mat-icon>
    </div>
    <p-tree
      [value]="naicsCodes"
      selectionMode="single"
      (onNodeSelect)="nodeSelected($event)"
      [style]="{ width: '100%' }"
    >
    </p-tree>
  </div>
</p-overlayPanel>
